
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vogel-actu/livv-newsletter",
      function () {
        return require("private-next-pages/vogel-actu/livv-newsletter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vogel-actu/livv-newsletter"])
      });
    }
  